module.exports = __webpack_public_path__ + "img/falksson-logo.14164980.png";